import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// // import { SignGuardGuard } from './tf/sign-guard.guard';
// import { GuestComponent } from './theme/layout/guest/guest.component';
// import { AdminComponent } from './theme/layout/admin/admin.component';
import { TfLoginComponent } from './tf/tf-login/tf-login.component';
import { AuthGuardGuard } from './tf/auth-guard.guard';
import { SignGuardGuard } from './tf/sign-guard.guard';
import { PreventPublicAccessGuard } from './tf/public-access.guard';
import { PermissionGuard } from './tf/permission.guard';
import { AdminComponent } from './Theme/layout/admin/admin.component';
import { GuestComponent } from './Theme/layout/guest/guest.component';
import { AboutUsComponent } from './Theme/shared/components/footer/about-us/about-us.component';
// // import { AuthGuardGuard } from './tf/auth-guard.guard';
// // import { PreventPublicAccessGuard } from './tf/public-access.guard';
 
const routes: Routes = [
  // Standalone routes (no layout/menu)
  {
    path: 'about',
    component: AboutUsComponent
  },
  {
    path: 'privacy',
    loadComponent: () => import('./Theme/shared/components/footer/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'terms',
    loadComponent: () => import('./Theme/shared/components/footer/termes-of-use/termes-of-use.component').then(m => m.TermesOfUseComponent)
  },
  {
    path: 'technical-support',
    loadComponent: () => import('./customer/cf-customer/cf-home/technical-support/technical-support.component').then(m => m.TechnicalSupportComponent)
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
      },
 
      {
        path: 'category',
        loadComponent: () =>
          import('./customer/cf-customer/cf-category/cf-category-list/cf-category-list.component').then((m) => m.CfCategoryListComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'cf_category.view_cf_category' }
      },
      // {
      //   path: 'sub-category/:id/:code',
      //   loadComponent: () =>
      //     import('./customer/cf-customer/cf-category/cf-sub-category-list/cf-sub-category-list.component').then((m) => m.CfSubCategoryListComponent),
      // },
      {
        path: 'sub-category/:categoryCode',
        loadComponent: () =>
          import('./customer/cf-customer/cf-category/cf-sub-category-list/cf-sub-category-list.component').then((m) => m.CfSubCategoryListComponent),
        canActivate: [PermissionGuard],
        data: { permission: 'cf_category.view_cf_category' }
      },

      //       {
      //   path: 'sub-category/:id',
      //   loadComponent: () =>
      //     import('./customer/cf-customer/cf-category/cf-sub-category-list/cf-sub-category-list.component').then((m) => m.CfSubCategoryListComponent),
      // },
      {
        path: 'compare',
        loadComponent: () =>
          import('./customer/cf-customer/cf-comparison/cf-comparison.component').then((m) => m.CfComparisonComponent),
      },
      {
        path: 'shopping-basket',
        loadComponent: () =>
          import('./customer/cp-customer/cp-shopping-basket/cp-shopping-basket-list/cp-shopping-basket-list.component').then((m) => m.CpShoppingBasketListComponent),
      },
      {
        path: 'confirmation/:basketId',
        loadComponent: () =>
          import('./customer/cp-customer/cp-shopping-basket/cp-confirmation-shopping-basket/cp-confirmation-shopping-basket.component').then((m) => m.CpConfirmationShoppingBasketComponent),
      },
      {
        path: 'basket-contact-support',
        loadComponent: () =>
          import('./customer/cp-customer/cp-shopping-basket/cp-basket-contact-support/cp-basket-contact-support.component').then((m)=> m.CpBasketContactSupportComponent),
      },
      {
        path: 'admin/cf-specifications/specifcation-product',
        loadComponent: () =>
          import('./admin/cf-admin/cf-product/navigation-product/navigation-product.component').then(m => m.NavigationProductComponent)
      },
      // {
      //   path: 'specifcation-by-item',
      //   loadComponent: () => import('./admin/cf-specifications/cf-specification-by-item/cf-specification-by-item.component').then(m => m.CfSpecificationsByItemComponent),
      // },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule), canActivate: [AuthGuardGuard]
      },
      {
        path: 'customer',
        loadChildren: () => import('./customer/customer.module').then((m) => m.CustomerModule), canActivate: [AuthGuardGuard]
      },
      {
        path: 'tf',
        loadChildren: () => import('./tf/tf.module').then((m) => m.TFModule)
      },
 
    ]
  },
 
  {
    path: '',
    component: GuestComponent,
    children: [
      {
        path: '',
        redirectTo: 'signin',
        pathMatch: 'full'
      },
      {
        path: 'auth',
        loadChildren: () => import('./tf/tf.module').then((m) => m.TFModule), canActivate: [SignGuardGuard]
      },
      {
        path: 'signin',
        component: TfLoginComponent
      },
      { path: '', loadChildren: () => import('./customer/cf-customer/cf-home/cf-home.module').then((m) => m.CfHomeModule),canActivate:[PreventPublicAccessGuard] },
    ]
  }
];
 
 
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }